import { Box } from "@chakra-ui/layout"
import { Heading, Text, chakra, Link, Flex } from "@chakra-ui/react"
import { ReactNode, useMemo } from "react"
import { FaRegSun } from "react-icons/fa6"
import HomeBackIcon from "src/components/views/home/HomeBackIcon"
import useSearchParams from "src/hooks/useSearchParams"

const LearnMachineOverlays = ({
  isMobileLandscape,
  isApp
}: {
  isMobileLandscape: boolean
  isApp: boolean
}) => {
  const year = useMemo(() => {
    const date = new Date()
    return date.getFullYear()
  }, [])

  const { isSecureInAppBrowser } = useSearchParams<{
    isSecureInAppBrowser?: true | undefined
  }>()

  return (
    <>
      {!isApp && !isSecureInAppBrowser && (
        <Link
          display="flex"
          flexDir="row"
          alignItems="center"
          pos="absolute"
          top={isMobileLandscape ? "6px" : ["6px", null, "24px"]}
          left={"14px"}
          href="https://learnmachine.ai"
          _focus={{}}
          _active={{}}
        >
          <FaRegSun color="orange" size="23px" />
          <Heading
            as="h1"
            fontFamily="roboto"
            fontWeight={400}
            fontSize="25px"
            textTransform="uppercase"
            letterSpacing="2px"
            color="white"
            mt="1px"
            ml="10px"
          >
            Learnmachine
          </Heading>
        </Link>
      )}
      {!isApp && !isSecureInAppBrowser && false && (
        <chakra.footer
          pos="absolute"
          bottom={0}
          left={0}
          width="100%"
          bg="black"
          borderTop="1px solid orange"
          padding="9px 10px"
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
        >
          <Text
            display="flex"
            alignItems="center"
            fontFamily="roboto"
            fontWeight={400}
            color="white"
            fontSize="12px"
            lineHeight={1.5}
          >
            © {year}&nbsp;
            <FaRegSun color="orange" size="12px" />
            &nbsp;LearnMachine
          </Text>

          <Flex gap={"3px"}>
            <Link href="https://learnmachine.ai/privacy">
              <Text
                color="white"
                fontSize="11px"
                fontFamily="Roboto"
                fontWeight="700"
              >
                Privacy
              </Text>
            </Link>
            <Text
              color="white"
              fontSize="11px"
              fontFamily="Roboto"
              fontWeight="700"
            >
              |
            </Text>
            <Link href="https://learnmachine.ai/terms">
              <Text
                color="white"
                fontSize="11px"
                fontFamily="Roboto"
                fontWeight="700"
              >
                Terms
              </Text>
            </Link>
          </Flex>
        </chakra.footer>
      )}
    </>
  )
}

const FormWrap = ({
  children,
  isMobileLandscape
}: {
  children: ReactNode
  isMobileLandscape: boolean
}) => (
  <Box
    borderRadius="40px"
    bg="rgba(22,22,22,0.5)"
    boxShadow="0 1px 6px rgba(57, 73, 76, 0.35)"
    p={4}
    px={"30px"}
    width={isMobileLandscape ? "560px" : "330px"}
    borderWidth="1px"
    border="none"
    pos="relative"
  >
    {children}
  </Box>
)

export const LandscapeFormWrap = ({ children }: { children: ReactNode }) => {
  return (
    <Box
      pos="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="rgba(22,22,22,0.5)"
      px={"16px"}
      width="100%"
      height="100%"
      borderWidth="1px"
      border="none"
    >
      <Box w="100%" maxW="580px" mx="auto">
        {children}
      </Box>
    </Box>
  )
}

const LearnMachineAuthScreen = ({
  children,
  isMobileLandscape,
  isApp,
  hideBackButton = true
}: {
  children: ReactNode
  isMobileLandscape: boolean
  isApp: boolean
  hideBackButton?: boolean
}) => {
  if (isMobileLandscape) {
    return (
      <>
        <LandscapeFormWrap>{children}</LandscapeFormWrap>
        <LearnMachineOverlays
          isMobileLandscape={isMobileLandscape}
          isApp={isApp}
        />
      </>
    )
  }

  return (
    <Flex align="center" justify="center" w="100%" h="100%" bg="black">
      <LearnMachineOverlays
        isMobileLandscape={isMobileLandscape}
        isApp={isApp}
      />
      <FormWrap isMobileLandscape={isMobileLandscape}>{children}</FormWrap>
      {!hideBackButton && (
        <div
          style={{
            width: "min-content",
            position: "absolute",
            top: "50px",
            left: 0
          }}
        >
          <HomeBackIcon
            JoinPageButtonTextColor={"white"}
            joinButtonBackgroundColor={"rgba(0, 0, 0, 0.65)"}
            navigatedFromiOS={history.length == 1}
            position="relative"
            top={"0px"}
            left={"8px"}
          />
        </div>
      )}
    </Flex>
  )
}

export default LearnMachineAuthScreen
